<template>
  <tutorial-layout title="Page Layouts" :referenceLinks="referenceLinks" :youtubeLinks="youtubeLinks">
    <p slot="overview">
        Description of the Page Layouts and how to use them. You are allowed to create your own page templates, but consider some benefits of using common templates:
    </p>
    <p slot="benefits">
      <ul>
        <li>
          Unified experience for end users in your app and across all UI.Core apps.
        </li>
        <li>
          Best practices implemented in the page templates.
        </li>
        <li>
          We will be improving and extending the layouts.
        </li>
      </ul>
    </p>
    <br/>
    <v-expansion-panels multiple accordion xl-12>
      
        <!-- Default Slots -->
        <v-expansion-panel>
            <v-expansion-panel-header>
                <h2>
                    Custom Left Navigation
                </h2>
            </v-expansion-panel-header>

            <v-expansion-panel-content>
                <p>Before using this layout: 
                   change routs to disable default left navigation for the pages with this layout. To do that, go to the ./routs/index.js file and add the next meta prop:
                    <pre><code>{
    path: 'home',
    name: 'Home',
    component: () => import(/* webpackChunkName: "custom-left-nav-home" */ '../views/Home.vue'),
    meta: {
        mainNavEnabled: false,
    },
},</code></pre>
                </p>
                <p>To start using just import the component to your Application.vue (or any vue page) and wrap your page content in the  &lt;page-layout-side-nav&gt;</p>
                <pre><code>import pageLayoutSideNav from "@/_components/page-layouts/page-layout-side-nav";</code></pre>
                <pre><code>&lt;page-layout-side-nav :version="version" :user="user" :isShowMainMenuLink="true" :navItems="items"&gt;
...
&lt;page-layout-side-nav/&gt;</code></pre>

                <h3>Component description: </h3>
                <v-list>

                    <h4>Props:</h4>
                    <v-list-item><code>version : {type:String, default: "0.0.1"},</code>  - displayed in the footer</v-list-item>
                    <v-list-item><code>user : {type:Object, default: null},</code>  - Name and picture are displayed in the Navigation Top bar</v-list-item>
                    <v-list-item><code>isShowMainMenuLink: {type:Boolean, default: true},</code>  - a first navigation link in the list, which is directing users back to the main page can be hidden if this prop is set to false.</v-list-item>
                    <v-list-item><code>navItems: {type:Array, default: []}</code>  - list of Navigation items to build navigation from. </v-list-item>
                    
                    <h4>Slots:</h4>
                    <v-list-item>leftNavItems - can be used to re-define the rendering of the left nav</v-list-item>
                    <v-list-item>default - for the main page content (usually router view if the tamplate is used in the Application.vue)</v-list-item>
                    <v-list-item>footer - to overwrite the footer of the page</v-list-item>
                </v-list>
                
                     <h4>Navigation Items Array format:</h4>
                    <pre><code>{
    icon: "mdi-home",
    text: "Home",
    link: "/custom-left-nav/home",
    roles: []
    },
    {
    icon: "mdi-cog",
    text: "Settings",
    link: "/custom-left-nav/config",
    roles: ["admin"]
    },
    {
    icon: "mdi-help",
    text: "Help",
    link: "/custom-left-nav/apphelp",
    items: [ 
            {
                icon: "mdi-help",
                text: "App Help Page",
                link: "/custom-left-nav/apphelp",
            },
            {
                icon: "mdi-help",
                text: "Global Help",
                link: "/custom-left-nav/help",
            },  
            ],
},</code></pre>

                <v-list>
                    <h4>How to filter Navigation items by user role</h4>
                    <v-list-item>
                        1. Get current user roles and assigned them to the user obj, e.g. <b>this.user.roles</b>
                    </v-list-item>                    
                    <v-list-item>
                        2. Get all Navigation Items from the app.config Settings, e.g. <b>this.settings.appNavigation</b>
                    </v-list-item> 
                    <v-list-item>
                        3. Filter using the next example: 
                    </v-list-item> 
                    <pre><code>this.settings.appNavigation.filter(x => !x.roles || x.roles.length === 0 || (this.user.roles && x.roles.filter(y => this.user.roles.includes(y)).length > 0));</code></pre>
                </v-list>

                <p>
                    <a href="/custom-left-nav/">Working example</a>
                </p>
            </v-expansion-panel-content>
        </v-expansion-panel>
         
    </v-expansion-panels>
    <!-- <br/>
    <v-divider></v-divider>
    <br/> -->
    <!-- <p><i>* </i></p> -->
  </tutorial-layout>
</template>

<script>
import uiView from "@/_mixins/ui-view-mixin";
import tutorialLayout from "../../components/tutorial-layout";

export default {
  name: "PageLayouts",
  mixins: [uiView],
  created() {},
  data: () => ({

  }),
  components: { tutorialLayout },
  props: {},
  watch: {},
  computed: {
    referenceLinks() {
      return [
      ];
    },
    youtubeLinks(){
      return [
      ]
    }
  },
  methods: {},
};
</script>
<style lang="scss">
pre {
  display: flex;
  max-width: 100%;
  flex: 0 0 100%;
  code {
    margin: 0px !important;
    width: 100%;
  }
}
</style>
